/**
 * RESPONSIBILITY: the head of the About page.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Img } from '@framework/core/decorators';
import type { ImageValue } from '@framework/core';
import { SectionName } from '../section-names';
import { ABOVE_HINT } from '../hints';

@Section({ name: SectionName.AboutHero, label: 'About · Page head' })
export class AboutHeroSection {
  @Text({
    label: 'Subtitle', maxLength: 120, default: 'Established in 2001',
    group: 'Page head', description: ABOVE_HINT,
  })
  eyebrow!: string;

  @Text({ label: 'Title', maxLength: 300, default: 'About ACFI', group: 'Page head' })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 3, group: 'Page head' })
  intro!: string;

  @Img({
    label: 'Image', folder: 'about', maxSizeMb: 12, size: '1920 × 1080',
    description: 'Across the top of the page.',
  })
  image!: ImageValue;
}
